<template>
  <header :class="$style.ctn">
    <a :class="$style.logo" aria-label="Interactive Sandbox" href="https://any.run" target="_blank">
      <SvgIcon width="130" height="55" src="icon-sprite.svg#logo_with_signature" />
    </a>
    <nav :class="$style.menu" v-show="showMenu">
      <MenuButton name="General" />
      <MenuButton name="Behavior" />
      <MenuButton name="MalConf" />
      <MenuButton name="Static information" />
      <MenuButton v-if="root.videoAndScreenshots.video" name="Video" />
      <MenuButton name="Screenshots" />
      <MenuButton
        name="System events"
        :ancors="ancors"
      />
      <MenuButton name="Network" />
    </nav>
    <div :class="$style.buttons" >
      <button :class="[$style.button, $style.mobileMenuButton]" type="button" @click="toggleMobileMenu">
        <div :class="[$style.mobileMenu, {[$style.mobileMenuOpen]: showMenu}]"><span/></div>
      </button>
      <button :class="$style.button" type="button" title="Print" @click="clickPrint">
        <SvgIcon width="24" height="24" src="icon-sprite.svg#print_button" />
      </button>
      <a v-if="root.meta.userSignedIn" :href="root.general.download" download>
        <SvgIcon width="24" height="24" src="icon-sprite.svg#download_button" />
      </a>
      <button v-else type="button" disabled title="We don't accepted direct downloading. Contact us if you are looking for Threat Intelligence plan (support@any.run)" :class="$style.button" >
        <SvgIcon width="24" height="24" src="icon-sprite.svg#download_button" />
      </button>
    </div>
  </header>
</template>
<script>
import { defineComponent } from 'vue';

import MenuButton from './MenuButton.vue';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { MenuButton, SvgIcon },
  inject: ['root', 'printRef'],
  data() {
    return {
      showMenu: false,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize)
  },
  computed:{
    ancors() {
      return [
          'Process',
          ...(this.root.registryActivity ? ['Registry activity'] : []),
          'Files activity',
          // 'Synchronization',
          // 'RPC Requests',
          'Debug',
        ]
    }
  },
  methods: {
    clickPrint() {
      this.printRef.value = 'buttonPrintEvent';
    },
    toggleMobileMenu() {
      this.showMenu = !this.showMenu;
    },
    onResize() {
      if (window.innerWidth >= 1040){
        this.showMenu = false
      }
    }
  },
});
</script>
<style lang="scss" module>

.buttons {
  display: flex;
  padding-bottom: 6px;
  gap: 12px;
}

.button {
  display: block;
  width: 24px;
  height: 24px;

  &:hover{
    --fill: #00B0E8;
  }

  @media print {
    display: none;
  }

  &:disabled {
    opacity: .6;
    cursor: default;

    &:hover {
      --fill: initial;
    }
  }

  svg {
    pointer-events: none;
  }
}

.ctn {
  border-bottom: 2px solid transparent;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
  z-index: 1;

  @media print {
    border-bottom: none;
  }

  &::after {
    pointer-events: none;
    content: '';
    width: 100%;
    position: absolute;
    display: block;
    height: 2px;
    top: 100%;
    background-color: rgba(63, 71, 87, 0.11);
    border-radius: 1px;

    @media print {
      background-color: transparent;
    }
  }
}

.ctn + * {
  margin-top: 47px;
  @media print {
    margin-top: 30px;
  }
}

.logo {
  display: block;
  width: 130px;
  height: 55px;
  margin-bottom: 10px;
  margin-right: auto;
  @media print {
    margin-bottom: 0px;
  }
}

.menu {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 21px;
  margin-right: 40px;

  @media screen and (min-width: 1041px) {
    display: grid !important;
  }

  @media screen and (max-width: 1040px) {
    position: absolute;
    right: 0;
    padding: 0;
    display: block;
    bottom: -335px;
    background: #fff;
    border: 1px solid #ccc;
    padding: 5px;
  }

  @media print {
    display: none;
  }
}
.mobileMenuButton{
  display: none;

  @media screen and (max-width: 1040px) {
    display: block;
  }
}

.mobileMenu {
  position: relative;
  width: 20px;
  height: 15px;
  transform: translateX(2px);

  &.mobileMenuOpen {
    span {
      display: none;
    }

    &::before {
      transform: rotate(45deg);
      top: 6px;
    }
    &::after {
      transform: rotate(-45deg);
      top: 6px;
    }
  }


  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--fill, #3F4757);
    border-radius: 2px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--fill, #3F4757);
    border-radius: 2px;
  }

  span {
    position: absolute;
    display: block;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--fill, #3F4757);
    border-radius: 2px;
    transform: translateY(-50%);
  }
}
</style>
